<template>
  <div id="login">
    <div class="content">
      <div class="logo">
        <img src="../assets/img/logo.png" />习讯云-校企合作平台
      </div>
      <div class="login">
        <div class="tab">
          <span :class="flag.tabIndex == 1 ? 'active' : ''" @click="flag.tabIndex = 1">用户名登录</span>
          <span :class="flag.tabIndex == 2 ? 'active' : ''" @click="flag.tabIndex = 2">手机号登录</span>
        </div>
        <div v-if="flag.tabIndex == 1">
          <div class="tab_phone">
            <div class="username">
              <i></i>
              <input type="text" placeholder="请输入账号" v-model="loginForm.name" />
            </div>
            <div class="pwd">
              <i></i>
              <input
                type="password"
                placeholder="请输入密码"
                v-model="loginForm.password"
                @keyup.enter.native="submit()"
              />
            </div>
          </div>
          <div class="btn">
            <span @click="submit">登录</span>
            <span @click="register">企业注册</span>
          </div>
        </div>
        <div v-if="flag.tabIndex == 2">
          <div class="tab_phone">
            <div class="username">
              <i></i>
              <input type="text" placeholder="请输入手机号码" v-model="loginForm2.mobile" />
            </div>
            <div class="pwd">
              <i></i>
              <input
                type="password"
                placeholder="请输入短信验证码"
                v-model="loginForm2.code"
                @keyup.enter.native="submit()"
              />
              <span v-if="!disabled" @click="sendcode">发送验证码</span>
              <span v-if="disabled">{{ btntxt }}</span>
            </div>
          </div>
          <div class="btn">
            <span @click="mobSubmit">登录</span>
            <span @click="register">企业注册</span>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="intro">
        <a href="http://www.vanber.cn" target="_blank">关于万博</a>
        <div style="margin-top:10px">地址：北京市海淀区苏州街3号大恒科技大厦南座5层 电话：0571-8802 6052</div>
        <div
          style="margin-top:10px"
        >Copyright ©2016-2019 Vanber. All Rights Reserved. 京ICP备15033449号-2</div>
      </div>
      <div class="float-box">
        <dl>
          <dd style="margin-right: 30px">
            <p>企校云小程序</p>
            <img src="../assets/img/qxiaoyunxcx.jpg" />
          </dd>
          <!-- <dd style="margin-right: 30px">
            <p>IOS客户端</p>
            <img src="../assets/img/ios.jpg" />
          </dd>-->
          <!-- <dd>
            <p>安卓客户端</p>
            <img src="../assets/img/android.png" />
          </dd>-->
        </dl>
      </div>
    </div>

    <div class="xx" v-if="flag.dialogVisible">
      <div class="box">
        <div class="main">
          <h3>付费成功！</h3>
          <p style="margin-bottom: 20px;">请用电脑登录习讯云校企合作平台 https://qxiaoyun.com</p>
        </div>
        <div class="member">
          <div class="t1">习讯-企校云平台</div>
          <div class="t2" style="color: #4090E6;">电脑登录网址：qxiaoyun.com</div>
          <div class="t2">校企合作/技能人才招聘一站式服务平台</div>
          <div class="t3">全国1000+学校&nbsp;&nbsp;&nbsp;&nbsp;100万+学生</div>
          <div class="t4">大数据精准匹配，开启您的校企合作之路</div>
          <div class="wechat">
            <div>
              <div>关注企校云服务号及时查看学生投递情况，发布或更新岗位信息</div>
              <img src="https://www.xixunyun.com/webapp-new/img/wx-xixun.jpg" />
            </div>
            <div style="margin-top: 20px;">
              <div>填加客服微信，反馈使用问题，及合作事宜</div>
              <img src="https://www.xixunyun.com/webapp-new/img/wx-person.jpg" />
            </div>
          </div>

          <!-- <div class="introduce">
            <div class="title">企业认证后的权益：</div>
            <div>
              <span></span>招聘岗位在线发布给全校学生，学生随时随地在线应聘
            </div>
            <div>
              <span></span>学校校企合作、校园招聘、毕业生推荐等优先合作推荐
            </div>
            <div>
              <span></span>每年第一时间获取学校招聘通知，免去频繁出差跑学校的麻烦
            </div>
            <div>
              <span></span>应往届毕业生人才全网推荐匹配，节省企业招聘成本
            </div>
            <div>
              <span></span>优先共享推荐校企合作平台全网数百所学校及其学生资源
            </div>
            <div>
              <span></span>平台为您构建企业人力资源储备库，丰富毕业生人才简历资源
            </div>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import baseUrl from "@/api/baseUrl";
import { isPC } from "@/assets/js/common.js";
import axios from "axios";

export default {
  name: "login",
  data() {
    return {
      activeName2: "first",
      loginForm: {
        name: "",
        password: ""
      },
      //手机号登录
      disabled: false,
      time: 0,
      btntxt: "重新发送",
      loginForm2: {
        mobile: "",
        code: ""
      },
      flag: {
        tabIndex: 1,
        dialogVisible: false
      }
    };
  },
  mounted() {
    if (this.$route.query.return === "alipay") {
      this.flag.dialogVisible = true;
      // document.body.style.position = "fixed";
    }
    if (this.$route.query.return === "alipay" && isPC()) {
      window.location.href = "https://qxiaoyun.com/#/pay-success";
    }
  },
  methods: {
    async login() {
      let res = await this.$api.account.login(this.loginForm);
      if (res.code === 0) {
        this.$message.success("登录成功！");
        this.$router.push("/");
        let { data } = await axios.get(
          baseUrl + "api/enterprise/school/list/province",
          {
            withCredentials: true
          }
        );
        if (data.code == 0) {
          localStorage.setItem('qxySchool', JSON.stringify(data.data));
        }
      }
    },
    async mobLogin() {
      let { data } = await axios.post(
        baseUrl + "api/enterprise/login/mobile",
        this.loginForm2,
        {
          withCredentials: true
        }
      );
      if (data.code === 0) {
        this.$message({
          message: "登录成功！",
          type: "success",
          center: true
        });
        localStorage.setItem("enterprise_name", data.data.name);
        this.$router.push("/");
      } else {
        this.$message({
          message: data.msg,
          center: true,
          type: "error"
        });
      }
    },
    submit() {
      // var _this = this
      if (this.loginForm.name === "") {
        this.$message({
          showClose: true,
          message: "请输入账号!",
          type: "warning"
        });
      } else if (this.loginForm.password === "") {
        this.$message({
          showClose: true,
          message: "请输入密码!",
          type: "warning"
        });
      } else {
        this.login();
      }
    },
    mobSubmit() {
      if (this.loginForm2.mobile === "") {
        this.$message({
          showClose: true,
          message: "请输入手机号!",
          type: "warning"
        });
      } else if (this.loginForm2.code === "") {
        this.$message({
          showClose: true,
          message: "请输入验证码!",
          type: "warning"
        });
      } else {
        this.mobLogin();
      }
    },
    register() {
      localStorage.setItem("regActive", 0);
      this.$router.push("/register");
    },
    //手机验证发送验证码
    async sendcode() {
      const reg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
      if (this.loginForm2.mobile == "") {
        this.$message({
          message: "手机号不能为空",
          center: true
        });
        return;
      }
      if (!reg.test(this.loginForm2.mobile)) {
        this.$message({
          message: "请输入正确的手机号",
          center: true
        });
        return;
      } else {
        // console.log(this.loginForm2.mobile);
        let res = await this.$api.common.sendCode({
          phone: this.loginForm2.mobile,
          type: "enterprise"
        });

        if (res.code === 0) {
          this.$message({
            message: "发送成功",
            type: "success",
            center: true
          });
          this.time = 60;
          this.disabled = true;
          this.timer();
        }
      }
    },
    //60S倒计时
    timer() {
      if (this.time > 0) {
        this.time--;
        this.btntxt = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.btntxt = "获取验证码";
        this.disabled = false;
      }
    },
    sure() {
      this.flag.dialogVisible = false;
      document.body.style.position = "static";
      // document.body.style.overflow='auto';
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/base.scss";

// 头部
.header {
  position: relative;
  height: 64px;
}

.logo {
  font-size: 28px;
  color: #333;
  font-weight: 400;
  height: 44px;
  line-height: 44px;
  left: 90px;
  top: 10px;
  position: absolute;

  img {
    width: 44px;
    height: 44px;
    float: left;
    margin-right: 17px;
  }
}

// 页面主体
@media screen and (max-width: 1280px) {
  .login {
    right: 34px;
  }
  .content {
    // height: 510px;
  }
}

@media screen and (min-width: 1281px) and (max-width: 1920px) {
  .content {
    // height: 700px;
  }
}

@media screen and (min-width: 1280px) and (max-width: 1450px) {
  .login {
    right: 34px;
  }
  .content {
    // height: 510px;
  }
}

@media screen and (min-width: 1450px) and (max-width: 1700px) {
  .login {
    right: 50px;
  }
  .content {
    // height: 715px;
  }
}

@media screen and (max-width: 500px) {
  #login {
    .content {
      height: auto;
      background: none;
      padding-top: 20px;
      display: block;
      .logo {
        position: static;
        text-align: center;
        img {
          display: none;
        }
      }
      .login {
        position: static;
        height: auto;
        padding: 20px;
        margin: 50px auto 0;
        .btn {
          span:last-child {
            display: none;
          }
        }
      }
    }
    .footer {
      display: none;
    }
  }
}

.content {
  position: relative;
  background: url("../assets/img/login-bg.png") no-repeat center center;
  background-size: 100%;
  // padding: 97px 0 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 626px;

  .des {
    width: 297px;
    height: 388px;
    background: url("../assets/img/bg1.png") no-repeat;
    background-size: contain;
    padding: 92px 0 0 33px;
    box-sizing: border-box;
    color: #fff;

    div:nth-of-type(1) {
      font-size: 38px;
      font-weight: bold;
      margin-bottom: 100px;
    }

    div:nth-of-type(2) {
      font-size: 23px;
      margin-bottom: 20px;
    }

    div:nth-of-type(3) {
      font-size: 14px;

      span:first-child {
        margin-right: 20px;
      }
    }
  }

  .login {
    position: absolute;
    right: 155px;
    top: 166px;
    width: 330px;
    height: 457px;
    padding: 90px 30px 123px 40px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 5px;

    .title {
      font-size: 20px;
      color: #000;
      margin-bottom: 20px;

      h3 {
        position: absolute;
        right: 0;
        top: 0;
        line-height: 40px;
      }
    }

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .tab {
      span {
        display: inline-block;
        width: 93px;
        height: 29px;
        text-align: center;
        line-height: 29px;
        border-radius: 14px;
        font-size: 14px;
        cursor: pointer;

        &:first-child {
          margin-right: 30px;
        }

        &.active,
        &:hover {
          color: #fff;
          background: $blue;
        }
      }
    }
  }
}

.tab_phone {
  padding-top: 30px;

  .username {
    display: flex;
    align-items: center;
    margin-bottom: 45px;

    i {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../assets/img/user1.png");
      background-size: contain;
      margin-right: 16px;
    }

    input {
      border: none;
      outline: none;
    }
  }

  .pwd {
    display: flex;
    align-items: center;
    font-size: 14px;

    i {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url("../assets/img/pwd1.png") no-repeat;
      background-size: contain;
      margin-right: 16px;
    }

    input {
      border: none;
      outline: none;
      width: 120px;
    }
  }

  .el-input {
    margin-bottom: 15px;
  }

  .input {
    height: 50px;

    .el-input__inner {
      height: 50px;
    }
  }

  .code {
    position: relative;

    .code_btn {
      position: absolute;
      right: 0;
      height: 50px;
    }
  }
}

.register {
  font-weight: bold;
  font-size: 20px;
  color: #0bb5ff;
  cursor: pointer;
}

.btn {
  margin-top: 30px;
  position: relative;
  text-align: center;
  font-size: 14px;

  span {
    cursor: pointer;
  }

  span:nth-of-type(1) {
    display: inline-block;
    width: 157px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    color: #fff;
    background: rgba(75, 127, 247, 1);
    border-radius: 20px;
    margin-right: 24px;
  }

  span:nth-of-type(2) {
    color: #4b7ff7;
  }
}

// 底部
.footer {
  height: 100px;
  text-align: center;
  font-size: 14px;
  margin-top: 50px;
  position: relative;

  a {
    color: #000;
  }

  .float-box {
    position: absolute;
    right: 90px;
    top: -60px;

    img {
      width: 150px;
      height: 150px;
    }

    dd {
      margin-left: 10px;
      margin-bottom: 30px;
      display: inline-block;
      padding: 15px 0 5px;
    }
  }
}

.lo {
  margin-top: 10px;
}

.xx {
  position: absolute;
  top: 0;
  left: 0;
  background: url("../assets/img/bg.png") no-repeat;
  background-size: cover;
  background-color: #fff;
  width: 100vw;
  height: 100vh;
  z-index: 100;
}

.box {
  margin: -10px auto;
  width: 100%;

  background-size: 100%;
  min-height: 650px;

  .sure {
    margin-left: 130px;
    margin-top: 5px;
  }

  .main {
    text-align: center;
    color: #fff;
    padding-top: vw(200);

    h3 {
      font-weight: bold;
      font-size: vw(42);
      margin-top: -57px;
    }

    p {
      margin-top: 0.06667vw;
      line-height: 30px;
      padding: 0 15px;
      font-size: vw(26);
    }
  }
  .member {
    width: 95vw;
    box-sizing: border-box;
    margin: vw(20) auto 0;
    padding: vw(80) 0 vw(50) 0;
    border: 1px solid #ddd;
    border-radius: vw(20);
    background: #fff;
    text-align: center;
    .introduce {
      padding: 10px 0;

      .title {
        font-size: vw(30);
        font-weight: bold;
        margin-bottom: vw(10);
      }

      div {
        display: flex;
        align-items: center;
        margin-right: vw(10);
        font-size: vw(24);
        line-height: 1.8;
      }

      div span {
        display: inline-block;
        width: vw(7);
        height: vw(7);
        border-radius: 50%;
        background: #4b7ff7;
        margin-right: vw(10);
      }
    }
    .t1 {
      font-size: vw(40);
      font-weight: bold;
    }
    .t2 {
      margin-top: 10px;
      font-size: vw(30);
    }
    .t3 {
      margin-top: 40px;
      color: $blue;
      font-size: vw(36);
      font-weight: bold;
    }
    .t4 {
      margin-top: 10px;
      color: $blue;
      font-size: vw(32);
    }
    .wechat {
      margin-top: 35px;

      img {
        width: 150px;
        height: 150px;
      }
    }
    .ope {
      margin-top: 20px;
      .el-button {
        width: 150px;
      }
      .ex {
        margin-top: 20px;
        color: red;
      }
    }
  }
}
</style>